var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPattern2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 112,
    viewBox: "0 0 393 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.517 128.352C391.135 131.091 385.453 130.02 382.343 126.035C382.005 125.602 382.07 124.977 382.497 124.633C385.075 122.549 385.784 119.089 383.884 115.463C383.646 115.009 383.816 114.445 384.252 114.175L385.985 113.099L387.712 112.012C388.147 111.738 388.728 111.833 389.032 112.247C391.457 115.543 394.878 116.422 397.88 115.02C398.379 114.788 398.969 115.003 399.21 115.498C401.428 120.039 399.898 125.615 395.517 128.352Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.293 66.2009C365.732 63.7034 362.379 62.9829 359.803 64.5928C357.226 66.2027 356.404 69.5325 357.964 72.03C358.611 73.0654 359.895 73.4299 360.832 72.8443C361.769 72.2588 362.003 70.9449 361.357 69.9103C359.796 67.4128 356.443 66.6923 353.866 68.3022C351.29 69.9121 350.468 73.2419 352.028 75.7394C355.229 80.8616 363.805 80.9585 365.313 80.0163C366.821 79.0741 370.494 71.3231 367.293 66.2009Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.846 110.456L313.03 111.591C312.093 112.177 310.859 111.892 310.274 110.955L309.578 109.841C309.297 109.391 308.848 109.071 308.331 108.952L307.051 108.656C305.975 108.408 305.304 107.334 305.553 106.258L305.848 104.978C305.967 104.461 305.877 103.918 305.596 103.468L304.899 102.354C304.314 101.417 304.599 100.184 305.536 99.598L306.65 98.9017C307.099 98.6209 307.419 98.1722 307.539 97.6555L307.834 96.3753C308.083 95.2991 309.156 94.6283 310.232 94.8767L311.513 95.1723C312.029 95.2916 312.573 95.2008 313.022 94.9199L314.137 94.2236C315.074 93.638 316.307 93.9228 316.893 94.8599L317.589 95.9742C317.87 96.4237 318.318 96.7435 318.835 96.8628L320.115 97.1583C321.191 97.4068 321.862 98.4804 321.614 99.5566L321.318 100.837C321.199 101.353 321.29 101.897 321.571 102.346L322.267 103.461C322.853 104.398 322.568 105.631 321.631 106.217L320.516 106.913C320.067 107.194 319.747 107.643 319.628 108.159L319.332 109.439C319.084 110.516 318.01 111.186 316.934 110.938L314.846 110.456Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.371 99.468C314.568 98.7203 316.067 99.3341 316.716 100.372C318.033 102.48 315.779 106.287 315.719 106.325C315.659 106.363 311.248 106.719 309.931 104.612C309.283 103.573 309.388 101.957 310.585 101.209C311.269 100.782 311.93 100.839 312.378 100.979C312.449 100.515 312.687 99.8956 313.371 99.468H313.371Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.038 -6.72973L383.659 -5.73582C385.122 -3.39436 384.41 -0.309092 382.069 1.15402V1.15402C379.727 2.61712 376.642 1.90483 375.179 -0.436628L374.247 -1.92834",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.069 1.15402L383.658 3.69816",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.102 -11.1422V-11.1422C380.507 -12.0203 382.358 -11.5931 383.236 -10.1879V-10.1879C384.114 -8.78264 383.686 -6.93203 382.281 -6.05395L376.853 -2.66194L376.769 -2.60947C374.662 -1.29262 371.885 -1.93365 370.568 -4.04105V-4.04105C369.251 -6.14845 369.892 -8.92506 372 -10.2419L372.084 -10.2944L374.968 -12.0966C376.373 -12.9747 378.224 -12.5475 379.102 -11.1422V-11.1422C379.98 -9.73702 379.553 -7.88641 378.147 -7.00834L375.695 -5.47581L375.669 -5.45991C374.967 -5.02114 374.041 -5.23492 373.602 -5.9371V-5.9371C373.164 -6.63929 373.377 -7.56528 374.08 -8.00406L374.105 -8.01995L375.801 -9.07979",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.305 28.3594L328.97 36.6918C327.969 37.3176 326.65 37.0132 326.024 36.0116L319.812 26.0691C319.186 25.0676 319.49 23.7489 320.492 23.123L333.826 14.7906C334.828 14.1648 336.147 14.4692 336.772 15.4707L342.985 25.4133C343.611 26.4148 343.307 27.7335 342.305 28.3594Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.235 22.3057C330.882 22.5276 330.624 22.8576 330.489 23.2343C330.352 23.6171 329.948 23.8693 329.544 23.8247C329.146 23.7807 328.735 23.8679 328.38 24.09C327.527 24.6225 327.367 25.9042 327.901 26.7581C329.067 28.6247 332.592 28.5328 332.988 28.2853C333.384 28.0379 335.012 24.91 333.846 23.0434C333.312 22.1894 332.089 21.7721 331.235 22.3057V22.3057Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.315 26.62L334.238 25.0397",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.575 28.0126L327.113 36.8856",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.132 14.8237L333.345 22.4967",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.614 25.9126L319.504 25.1433",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.479 54.8504L275.515 58.3602C275.345 58.982 275.798 59.5997 276.442 59.6243L285.425 59.9573C286.244 59.9873 286.998 59.5157 287.33 58.7671L290.965 50.5539C291.227 49.962 290.867 49.2807 290.23 49.1656L286.674 48.5219",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.613 59.1259L280.501 66.9491C280.801 67.4291 281.424 67.581 281.893 67.2885L295.461 58.8098C295.929 58.5172 296.066 57.8906 295.766 57.4106L290.878 49.5873",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.14 67.405L282.88 59.8675",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.359 56.4442L295.896 58.1844",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.673 53.321L284.757 45.4528C284.464 44.9847 283.847 44.8421 283.379 45.1346L274.898 50.4338C274.43 50.7264 274.288 51.3437 274.58 51.8118L279.497 59.68",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.303 50.5236C283.2 49.9629 284.296 50.3762 284.755 51.1115C285.688 52.6049 283.953 55.3881 283.908 55.4167C283.862 55.4453 280.6 55.7844 279.667 54.291C279.207 53.5557 279.316 52.39 280.213 51.8293C280.726 51.5087 281.213 51.5383 281.542 51.6301C281.603 51.2946 281.79 50.8442 282.303 50.5236Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.863 81.6991L236.736 74.2802C237.673 73.6947 238.906 73.9794 239.492 74.9165L246.381 85.9411",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.794 94.8443V94.8443C238.731 94.2587 239.016 93.0254 238.43 92.0883L237.9 91.2403",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.452 79.7995C236.169 79.3512 237.046 79.682 237.413 80.2705C238.159 81.4646 236.772 83.6914 236.735 83.7142",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.779 80.8445C233.062 81.2928 232.975 82.2256 233.343 82.8141C234.089 84.0082 236.699 83.737 236.735 83.7142",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.842 80.685C234.891 80.4162 235.041 80.056 235.452 79.7995",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.842 80.685C234.579 80.6112 234.19 80.588 233.779 80.8445",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.781 87.8481L241.717 84.1387",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.9 91.2403L248.077 84.8813L248.551 85.6403C249.168 86.6265 248.868 87.9246 247.882 88.5409V88.5409L237.794 94.8443C236.857 95.4298 235.624 95.1451 235.038 94.208L228.149 83.1834L227.619 82.3353C227.034 81.3982 225.8 81.1135 224.863 81.6991V81.6991C223.926 82.2846 223.642 83.5179 224.227 84.455L224.757 85.3031",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.757 85.3031L228.149 83.1834",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.492 114.767L191.365 107.348C192.302 106.762 193.535 107.047 194.121 107.984L199.95 117.313C200.536 118.25 200.251 119.483 199.314 120.069L189.137 126.428C188.2 127.013 186.967 126.728 186.381 125.791L179.519 114.81C179.051 114.061 179.13 113.095 179.712 112.431L186.798 104.357C187.24 103.853 188.043 103.918 188.398 104.486L190.517 107.878",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.859 113.005C191.115 112.221 192.649 112.8 193.293 113.829C194.598 115.919 192.169 119.816 192.106 119.856C192.042 119.896 187.475 120.37 186.169 118.281C185.526 117.251 185.678 115.619 186.934 114.834C187.652 114.385 188.333 114.426 188.793 114.554C188.879 114.085 189.141 113.454 189.859 113.005Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.719 5.9111L248.111 3.79142",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.97 8.98671V8.98671C260.151 10.1234 257.749 9.37438 256.905 7.40801L254.46 1.70764C254.265 1.2549 254.431 0.726502 254.851 0.464192L257.617 -1.26441C258.048 -1.5336 258.612 -1.439 258.929 -1.0437L262.849 3.83531C264.159 5.46582 263.748 7.876 261.97 8.98671Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.676 11.4234L248.022 11.4234C249.552 11.4239 250.947 10.5516 251.618 9.17654L252.207 7.96724",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.269 2.36007L245.117 1.83015C245.585 1.53763 246.202 1.68015 246.495 2.14828L247.6 3.91646C248.611 5.53453 250.042 6.84758 251.741 7.71376V7.71376C253.441 8.58078 254.872 9.89383 255.883 11.5111L258.048 14.9753C258.633 15.9124 258.348 17.1457 257.411 17.7313L253.171 20.3809C252.234 20.9664 251.001 20.6817 250.415 19.7446L248.25 16.2803C247.239 14.6623 246.687 12.8002 246.653 10.8933V10.8933C246.619 8.98549 246.066 7.12344 245.056 5.50621L243.951 3.73803C243.658 3.26991 243.801 2.65258 244.269 2.36007Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.418 12.5972C253.135 12.1489 254.012 12.4797 254.38 13.0683C255.126 14.2623 253.738 16.4891 253.701 16.5119C253.665 16.5347 251.055 16.8059 250.309 15.6119C249.941 15.0233 250.028 14.0905 250.746 13.6422C251.156 13.3858 251.545 13.4089 251.809 13.4827C251.858 13.2139 252.007 12.8537 252.418 12.5972V12.5972Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.97 8.98672L264.62 13.227",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.924 14.2868L266.316 12.1671",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.898 1.40233L255.717 4.64013",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.534 35.0303C199.753 35.3816 200.216 35.4884 200.567 35.2689C200.919 35.0494 201.025 34.5867 200.806 34.2354L199.534 35.0303ZM198.686 30.8432C198.467 30.4919 198.004 30.3851 197.653 30.6046C197.301 30.8241 197.195 31.2868 197.414 31.6381L198.686 30.8432ZM206.318 30.7909C206.538 31.1422 207 31.249 207.352 31.0295C207.703 30.81 207.81 30.3473 207.59 29.9961L206.318 30.7909ZM205.471 26.6039C205.251 26.2526 204.788 26.1458 204.437 26.3653C204.086 26.5848 203.979 27.0475 204.198 27.3987L205.471 26.6039ZM200.806 34.2354L198.686 30.8432L197.414 31.6381L199.534 35.0303L200.806 34.2354ZM207.59 29.9961L205.471 26.6039L204.198 27.3987L206.318 30.7909L207.59 29.9961Z",
    fill: "#5458F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.519 39.8266L212.784 30.288",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.93 37.2825L202.819 48.3071C203.404 49.2442 204.637 49.5289 205.574 48.9433L217.447 41.5245C218.384 40.9389 218.669 39.7056 218.083 38.7685L211.194 27.7439C210.609 26.8068 209.376 26.5221 208.439 27.1076L196.566 34.5265C195.629 35.1121 195.344 36.3454 195.93 37.2825Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.051 37.3726C208.949 36.812 210.044 37.2253 210.503 37.9605C211.436 39.4531 209.702 42.2371 209.656 42.2657",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.962 38.6784C205.064 39.239 204.956 40.4048 205.415 41.14C206.348 42.6326 209.61 42.2943 209.656 42.2657",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.29 38.4792C207.352 38.1436 207.538 37.6932 208.051 37.3726",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.29 38.4792C206.961 38.3874 206.475 38.3577 205.962 38.6783",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.221 71.624L158.349 79.0428C157.412 79.6284 156.178 79.3437 155.593 78.4066L154.003 75.8624C153.417 74.9253 153.702 73.6921 154.639 73.1065L166.512 65.6876C167.449 65.1021 168.682 65.3868 169.268 66.3239L170.858 68.868C171.443 69.8051 171.159 71.0384 170.221 71.624Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.928 66.6775L156.334 72.0477C155.398 72.6322 154.165 72.3475 153.581 71.4121L151.989 68.8646C151.404 67.9292 151.689 66.6959 152.624 66.1114L161.108 60.8101C162.044 60.2256 163.277 60.5103 163.861 61.4457L165.522 64.1035C166.069 64.9787 165.803 66.1306 164.928 66.6775V66.6775Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.261 58.5676C156.159 58.007 157.254 58.4203 157.714 59.1555C158.646 60.6481 156.912 63.4321 156.866 63.4607C156.82 63.4893 153.558 63.8285 152.625 62.335C152.166 61.5998 152.275 60.434 153.172 59.8734C153.685 59.5528 154.172 59.5824 154.5 59.6742C154.562 59.3386 154.748 58.8882 155.261 58.5676Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.798 67.1719C169.337 67.4597 168.965 67.8891 168.791 68.3908C168.616 68.8926 168.244 69.322 167.784 69.6097C167.323 69.8975 166.774 70.0436 166.247 69.9806C165.719 69.9176 165.17 70.0637 164.71 70.3515C164.249 70.6392 163.877 71.0686 163.702 71.5704C163.528 72.0721 163.156 72.5015 162.695 72.7893C162.235 73.077 161.686 73.2231 161.158 73.1601C160.631 73.0971 160.082 73.2432 159.621 73.531C159.161 73.8187 158.789 74.2481 158.614 74.7499C158.44 75.2517 158.068 75.681 157.607 75.9688C157.147 76.2565 156.598 76.4026 156.07 76.3396C155.542 76.2766 154.993 76.4227 154.533 76.7105",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.392 62.2954C164.034 62.5191 163.765 62.8843 163.668 63.3379C163.571 63.7909 163.302 64.1562 162.943 64.3803C162.585 64.6039 162.139 64.6859 161.688 64.5747C161.238 64.4635 160.792 64.5449 160.434 64.7691C160.075 64.9933 159.806 65.358 159.709 65.8115C159.612 66.2646 159.343 66.6298 158.984 66.854C158.625 67.0781 158.18 67.1596 157.73 67.0484C157.28 66.9366 156.834 67.0186 156.475 67.2428C156.116 67.4669 155.849 67.8306 155.753 68.2836C155.656 68.7367 155.387 69.1019 155.028 69.3261C154.67 69.5497 154.224 69.6317 153.773 69.5204C153.324 69.4087 152.878 69.4907 152.52 69.7143",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1447 93.4717C99.804 94.4099 101.155 94.4408 101.911 93.5639C104.749 90.2741 109.317 89.1458 113.005 91.1068C116.692 93.0677 118.311 97.4859 117.171 101.678C116.866 102.795 117.647 103.898 118.794 103.921",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.791 88.7451C117.513 87.3877 116.592 85.482 116.127 85.2347C115.663 84.9882 113.567 85.2895 112.846 86.647C112.573 87.1623 112.759 87.9186 113.326 88.22C113.631 88.3819 113.979 88.4085 114.279 88.3058C114.425 88.2555 114.574 88.3348 114.614 88.4842C114.697 88.7899 114.915 89.0638 115.22 89.2271C115.786 89.529 116.518 89.2604 116.791 88.7451V88.7451Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.885 105.475L109.965 101.564L108.826 98.9666L106.046 99.4548L103.967 103.366L106.746 102.878L107.885 105.475Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.487 88.3148L108.821 98.9661",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.067 94.1064L105.296 100.874",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.206 102.724L109.227 102.957",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern2);
export default __webpack_public_path__ + "static/media/pattern2.a1e42d1c.svg";
export { ForwardRef as ReactComponent };